import { PATH_SIGNAL_NOTIFICATIONS, PATH_STRATEGIES_SUB_PLANS, PATH_SUBSCRIPTIONS } from './path';
import * as handler from './handler';

const startNotifications = (strategyId, payload, userId) =>
  handler.post(`${PATH_SIGNAL_NOTIFICATIONS}/${userId}/${strategyId}`, payload).then((res) => {
    return res;
  });

const getSubscriptions = (strategyId) =>
  handler.get(`${PATH_STRATEGIES_SUB_PLANS}signal-notification/${strategyId}`).then((res) => {
    return res;
  });

const subscribeToNotification = (payload, userId) =>
  handler.post(`${PATH_SUBSCRIPTIONS + userId}/signal-notifications`, payload).then((res) => {
    return res;
  });

const getSubscriptionDetails = (strategyId, userId) =>
  handler.get(`${PATH_SUBSCRIPTIONS + userId}/signal-notifications/${strategyId}`).then((res) => {
    return res;
  });

export default { startNotifications, getSubscriptions, subscribeToNotification, getSubscriptionDetails };
